import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('RemoteDesktopExercise', 'v4');
export default exerciseTypeVersionAdapter;